import React from "react";
import style from "./Copyright.module.css";
import PageLayout from "../../components/PageLayout/PageLayout";

const Copyright: React.FC = () => {
  return (
    <PageLayout className={style.Copyright}>
      <div className={style.Policy}>
        <h1 className={style.Title}>
          Regulamin Serwisu Internetowego CARTENA
        </h1>

        <section>
          <h2 className={style.SectionTitle}>
            §1. Postanowienia ogólne
          </h2>

          <ol>
            <li>
              Niniejszy Regulamin określa zasady korzystania z serwisu
              internetowego CARTENA, dostępnego pod adresem
              www.cartena.pl, zwanego dalej „Serwisem”.
            </li>

            <li>
              Właścicielem i usługodawcą Serwisu jest CARTENA Paweł Świeć,
              z siedzibą w Gdańsku przy ul. Ptasiej 18,
              80-035 Gdańsk, wpisana do Centralnej Ewidencji
              i Informacji o Działalności Gospodarczej (CEIDG),
              NIP: 5833108652.
            </li>

            <li>
              Kontakt z Administratorem Serwisu jest możliwy
              pod adresem e-mail: kontakt@cartena.com.pl.
            </li>

            <li>
              CARTENA jest internetowym katalogiem firm transportowych
              oraz przedsiębiorstw świadczących usługi związane
              z transportem i pojazdami specjalistycznymi.
            </li>

            <li>
              Korzystanie z publicznej wyszukiwarki i przeglądanie
              wizytówek firm jest bezpłatne i nie wymaga rejestracji.
            </li>
          </ol>
        </section>

        <section>
          <h2 className={style.SectionTitle}>
            §2. Definicje
          </h2>

          <ol>
            <li>
              <strong>Serwis</strong> – platforma internetowa CARTENA,
              dostępna pod adresem www.cartena.pl.
            </li>

            <li>
              <strong>Administrator</strong> – podmiot prowadzący Serwis,
              wskazany w §1 Regulaminu.
            </li>

            <li>
              <strong>Użytkownik</strong> – osoba korzystająca z Serwisu.
            </li>

            <li>
              <strong>Użytkownik zarejestrowany</strong> – osoba
              posiadająca konto w Serwisie.
            </li>

            <li>
              <strong>Wizytówka firmy</strong> – zbiór informacji
              o przedsiębiorstwie, obejmujący między innymi nazwę,
              dane kontaktowe, lokalizację, rodzaje pojazdów
              i opis świadczonych usług.
            </li>

            <li>
              <strong>Właściciel wizytówki</strong> – użytkownik,
              któremu przypisano uprawnienia do zarządzania
              daną wizytówką w Serwisie.
            </li>

            <li>
              <strong>Okres obowiązywania pakietu</strong> – czas,
              przez który wizytówka korzysta z funkcji pakietu
              Rozszerzonego lub dodatkowych usług promocyjnych.
              Upływ tego okresu nie oznacza usunięcia wizytówki
              z bezpłatnego katalogu.
            </li>

            <li>
              <strong>Wyróżnienie</strong> – dodatkowa usługa
              zwiększająca widoczność wizytówki w Serwisie.
            </li>

            <li>
              <strong>TOP3</strong> – usługa promowania wizytówki
              wśród maksymalnie trzech firm w określonej
              kategorii pojazdów i województwie.
            </li>
          </ol>
        </section>

        <section>
          <h2 className={style.SectionTitle}>
            §3. Zakres usług Serwisu
          </h2>

          <ol>
            <li>
              Serwis umożliwia wyszukiwanie firm według dostępnych
              kryteriów, w szczególności województwa,
              kategorii pojazdów oraz rodzaju świadczonych usług.
            </li>

            <li>
              Użytkownicy mogą bezpłatnie przeglądać wizytówki
              przedsiębiorstw oraz korzystać z udostępnionych
              w nich danych kontaktowych.
            </li>

            <li>
              Użytkownicy zarejestrowani mogą korzystać
              z funkcji dodawania i zarządzania wizytówkami,
              w zakresie uprawnień przyznanych w Serwisie.
            </li>

            <li>
              CARTENA oferuje bezterminowe wizytówki w pakiecie
              Darmowym, czasowy pakiet Rozszerzony oraz dodatkowe
              usługi promowania wizytówek firm.
            </li>

            <li>
              CARTENA nie świadczy usług transportowych
              w imieniu przedsiębiorstw prezentowanych w katalogu.
            </li>

            <li>
              Umowy dotyczące usług transportowych są zawierane
              bezpośrednio pomiędzy zainteresowanymi stronami,
              niezależnie od CARTENA.
            </li>
          </ol>
        </section>

        <section>
          <h2 className={style.SectionTitle}>
            §4. Dodawanie i publikowanie wizytówek
          </h2>

          <ol>
            <li>
              Wizytówki firm mogą być dodawane przez uprawnionych
              użytkowników oraz Administratora Serwisu.
            </li>

            <li>
              Administrator może tworzyć wizytówki przedsiębiorstw
              na podstawie legalnie pozyskanych informacji
              dotyczących ich działalności gospodarczej.
            </li>

            <li>
              Źródłami informacji mogą być publiczne rejestry,
              oficjalne strony internetowe przedsiębiorstw
              oraz dane przekazane bezpośrednio przez firmy.
            </li>

            <li>
              Osoba dodająca wizytówkę lub przekazująca dane
              do publikacji powinna zadbać o ich prawdziwość,
              aktualność oraz zgodność z prawem.
            </li>

            <li>
              Administrator może weryfikować, aktualizować
              i poprawiać informacje zamieszczone w wizytówkach.
            </li>

            <li>
              Publikacja wizytówki może być uzależniona
              od spełnienia wymagań technicznych
              oraz warunków udostępnionych w Serwisie.
            </li>

            <li>
              Administrator może odmówić publikacji lub
              dezaktywować wizytówkę zawierającą informacje
              nieprawdziwe, bezprawne, wprowadzające w błąd
              albo niezwiązane z profilem Serwisu.
            </li>

            <li>
              Przedsiębiorca może zgłosić potrzebę aktualizacji,
              sprostowania lub usunięcia informacji dotyczących
              jego firmy. Zgłoszenie zostanie rozpatrzone
              z uwzględnieniem obowiązujących przepisów prawa.
            </li>

            <li>
              Zgłoszenia należy przesyłać na adres
              kontakt@cartena.com.pl. Administrator może
              poprosić o potwierdzenie uprawnienia
              do reprezentowania danej firmy.
            </li>

            <li>
              Publikowanie informacji dotyczących osób fizycznych
              odbywa się z uwzględnieniem zasad ochrony danych
              osobowych opisanych w Polityce prywatności.
            </li>
          </ol>
        </section>

        <section>
          <h2 className={style.SectionTitle}>
            §5. Pakiety wizytówek i usługi płatne
          </h2>

          <ol>
            <li>
              Dodanie i utrzymywanie wizytówki firmy w pakiecie
              Darmowym jest bezpłatne i bezterminowe, z zastrzeżeniem
              zasad dotyczących zgodności treści z Regulaminem
              oraz możliwości dezaktywacji lub usunięcia wizytówki.
            </li>

            <li>
              Nowo dodana firma otrzymuje pakiet Rozszerzony
              bezpłatnie na pierwsze 12 miesięcy. Pakiet ten
              umożliwia publiczne wyświetlanie logo firmy
              oraz jednego zdjęcia.
            </li>

            <li>
              Po upływie okresu obowiązywania pakietu Rozszerzonego,
              jeżeli nie został on przedłużony, wizytówka
              automatycznie korzysta z funkcji pakietu Darmowego.
              Pozostaje dostępna w katalogu, jednak logo i zdjęcia
              nie są publicznie wyświetlane.
            </li>

            <li>
              Przedłużenie pakietu Rozszerzonego jest opcjonalne.
              Brak przedłużenia nie powoduje naliczenia opłaty
              za dalszą obecność wizytówki w pakiecie Darmowym.
            </li>

            <li>
              Pakiet Darmowy obejmuje podstawowe dane firmy,
              dane kontaktowe i opis usług, bez publicznego
              wyświetlania logo i zdjęć. Pakiet Rozszerzony
              udostępnia logo i jedno zdjęcie; aktywne Wyróżnienie
              udostępnia do trzech zdjęć, a aktywna usługa TOP3
              do pięciu zdjęć. Dostępność funkcji promocyjnych
              wymaga aktywnego pakietu Rozszerzonego.
            </li>

            <li>
              Zakres publicznej prezentacji materiałów w poszczególnych
              pakietach jest następujący:
              <ul>
                <li>Pakiet Darmowy: bez logo i bez zdjęć.</li>
                <li>Pakiet Rozszerzony: logo i maksymalnie 1 zdjęcie.</li>
                <li>Pakiet Wyróżniony: logo i maksymalnie 3 zdjęcia.</li>
                <li>Pakiet Polecane TOP 3: logo i maksymalnie 5 zdjęć.</li>
              </ul>
              Wyróżnienie i TOP 3 wymagają aktywnego pakietu
              Rozszerzonego. Po wygaśnięciu uprawnień do wyświetlania
              logo lub zdjęć materiały pozostają zapisane w wizytówce,
              ale nie są publicznie prezentowane. Mogą być ponownie
              wyświetlane po aktywacji odpowiedniego pakietu.
            </li>

            <li>
              Serwis oferuje dodatkowe usługi promowania
              wizytówek, w szczególności wyróżnienie oraz TOP3.
            </li>

            <li>
              Usługa TOP3 umożliwia promowanie wizytówki
              wśród maksymalnie trzech firm w określonej
              kategorii pojazdów i województwie.
            </li>

            <li>
              Zamówienie usługi TOP3 jest możliwe wyłącznie
              w przypadku dostępności miejsca w wybranej
              kategorii i województwie.
            </li>

            <li>
              Ceny, zakres usług oraz okresy ich obowiązywania
              są przedstawiane użytkownikowi przed złożeniem
              zamówienia.
            </li>

            <li>
              Zamówienie usługi płatnej następuje zgodnie
              z procesem zamawiania udostępnionym w Serwisie.
              Przed złożeniem zamówienia użytkownik powinien
              mieć możliwość zapoznania się z jego warunkami,
              w tym ceną i okresem świadczenia usługi.
            </li>

            <li>
              Płatności za zamówione usługi są realizowane
              przelewem bankowym zgodnie z informacjami
              przekazanymi użytkownikowi podczas zamawiania.
            </li>

            <li>
              Administrator ręcznie weryfikuje otrzymanie
              płatności za zamówioną usługę.
            </li>

            <li>
              Aktywacja zakupionej usługi następuje po otrzymaniu
              i ręcznym zweryfikowaniu płatności przez Administratora.
              Do czasu potwierdzenia płatności zamówiona usługa
              pozostaje nieaktywna.
            </li>

            <li>
              Okres świadczenia zakupionej usługi rozpoczyna się
              od momentu jej aktywacji przez Administratora,
              chyba że warunki konkretnego zamówienia
              przewidują inny termin rozpoczęcia.
            </li>

            <li>
              Administrator może przyznać firmie dodatkowy
              bezpłatny okres pakietu Rozszerzonego lub promocji
              na indywidualnie ustalonych warunkach.
            </li>

            <li>
              Samo wyłączenie widoczności wizytówki nie powoduje
              automatycznego wstrzymania biegu aktywnego
              okresu pakietu Rozszerzonego lub promocji.
            </li>

            <li>
              W przypadku rezygnacji z zakupionej usługi,
              dezaktywacji wizytówki lub żądania jej usunięcia,
              ewentualne rozliczenie niewykorzystanej części
              usługi następuje zgodnie z warunkami zawartej
              umowy oraz obowiązującymi przepisami prawa.
            </li>

            <li>
              Jeżeli nabywcy przysługuje ustawowe prawo
              odstąpienia od umowy, może on skorzystać
              z niego na zasadach przewidzianych prawem.
              Informacje wymagane przepisami powinny zostać
              przekazane przed zawarciem umowy.
            </li>

            <li>
              Zamówienie usługi płatnej nie oznacza
              zagwarantowania określonej liczby wyświetleń,
              zapytań, kontaktów handlowych ani pozyskania klientów.
            </li>
          </ol>
        </section>

        <section>
          <h2 className={style.SectionTitle}>
            §6. Rejestracja i konta użytkowników
          </h2>

          <ol>
            <li>
              Rejestracja konta wymaga podania danych
              wskazanych w formularzu rejestracyjnym.
            </li>

            <li>
              Użytkownik zobowiązuje się do podawania
              prawdziwych danych i zabezpieczenia
              dostępu do swojego konta.
            </li>

            <li>
              Zabronione jest udostępnianie danych logowania
              osobom nieuprawnionym oraz korzystanie
              z cudzych kont bez zgody ich właścicieli.
            </li>

            <li>
              Użytkownik może posiadać uprawnienia
              do zarządzania więcej niż jedną wizytówką firmy.
            </li>

            <li>
              Użytkownik powinien niezwłocznie poinformować
              Administratora o podejrzeniu nieuprawnionego
              dostępu do swojego konta.
            </li>

            <li>
              W sprawach dotyczących konta, w tym jego
              zamknięcia, użytkownik może skontaktować się
              z Administratorem pod adresem
              kontakt@cartena.com.pl.
            </li>

            <li>
              Zamknięcie konta nie musi oznaczać
              natychmiastowego usunięcia danych,
              których dalsze przechowywanie jest wymagane
              przepisami prawa lub niezbędne do ustalenia,
              dochodzenia albo obrony roszczeń.
            </li>
          </ol>
        </section>

        <section>
          <h2 className={style.SectionTitle}>
            §7. Zasady korzystania z Serwisu
          </h2>

          <ol>
            <li>
              Użytkownik zobowiązuje się korzystać
              z Serwisu zgodnie z prawem, Regulaminem
              oraz dobrymi obyczajami.
            </li>

            <li>
              Zabronione jest publikowanie treści
              naruszających prawa osób trzecich,
              wprowadzających w błąd lub niezwiązanych
              z działalnością prezentowanej firmy.
            </li>

            <li>
              Zabronione jest podejmowanie działań
              zakłócających działanie Serwisu,
              naruszających jego bezpieczeństwo
              lub utrudniających korzystanie z niego
              innym użytkownikom.
            </li>

            <li>
              Niedozwolone jest masowe, automatyczne
              pobieranie zawartości bazy danych
              z naruszeniem praw przysługujących CARTENA
              lub innym uprawnionym podmiotom.
            </li>

            <li>
              Administrator może ograniczyć dostęp
              do określonych funkcji w przypadku
              naruszenia Regulaminu, z uwzględnieniem
              obowiązujących przepisów prawa.
            </li>
          </ol>
        </section>

        <section>
          <h2 className={style.SectionTitle}>
            §8. Odpowiedzialność
          </h2>

          <ol>
            <li>
              CARTENA dokłada starań, aby informacje
              publikowane w katalogu były prawidłowe
              i aktualne.
            </li>

            <li>
              Informacje dotyczące usług, pojazdów,
              dostępności oraz zakresu działalności
              firm powinny być potwierdzane
              bezpośrednio u danego przedsiębiorcy.
            </li>

            <li>
              CARTENA nie świadczy usług transportowych
              w imieniu firm prezentowanych w katalogu
              i nie jest stroną zawieranych z nimi
              umów transportowych.
            </li>

            <li>
              Za prawdziwość i zgodność z prawem
              informacji przekazanych do publikacji
              odpowiada podmiot, który je przekazał,
              na zasadach wynikających
              z obowiązujących przepisów.
            </li>

            <li>
              Administrator może czasowo ograniczyć
              dostęp do Serwisu z przyczyn technicznych,
              konserwacyjnych lub związanych
              z bezpieczeństwem.
            </li>

            <li>
              CARTENA nie gwarantuje nieprzerwanego
              działania Serwisu, jednak podejmuje
              działania mające na celu zapewnienie
              jego prawidłowego funkcjonowania.
            </li>

            <li>
              Postanowienia Regulaminu nie wyłączają
              ani nie ograniczają odpowiedzialności,
              której nie można wyłączyć lub ograniczyć
              na podstawie obowiązujących przepisów prawa.
            </li>
          </ol>
        </section>

        <section>
          <h2 className={style.SectionTitle}>
            §9. Ochrona bazy danych i praw autorskich
          </h2>

          <ol>
            <li>
              Struktura Serwisu, jego elementy graficzne,
              oprogramowanie oraz baza danych mogą
              podlegać ochronie na podstawie
              obowiązujących przepisów prawa.
            </li>

            <li>
              Korzystanie z Serwisu nie oznacza
              przeniesienia na użytkownika praw autorskich
              ani praw do bazy danych.
            </li>

            <li>
              Prawa do materiałów przekazanych
              przez przedsiębiorców lub inne podmioty
              pozostają przy ich uprawnionych właścicielach,
              chyba że odrębne ustalenia stanowią inaczej.
            </li>

            <li>
              Zabronione jest wykorzystywanie chronionych
              elementów Serwisu w sposób naruszający
              prawa CARTENA lub innych uprawnionych
              podmiotów.
            </li>
          </ol>
        </section>

        <section>
          <h2 className={style.SectionTitle}>
            §10. Dane osobowe i pliki cookies
          </h2>

          <ol>
            <li>
              Zasady przetwarzania danych osobowych
              zostały opisane w Polityce prywatności
              dostępnej w Serwisie.
            </li>

            <li>
              Serwis wykorzystuje pamięć lokalną
              przeglądarki (localStorage) do przechowywania
              tokenu uwierzytelniającego użytkownika.
            </li>

            <li>
              Serwis wykorzystuje plik cookie
              do zapamiętywania decyzji użytkownika
              dotyczącej komunikatu o plikach cookies.
            </li>

            <li>
              Użytkownik może zarządzać danymi
              przechowywanymi w przeglądarce
              za pomocą jej ustawień.
            </li>

            <li>
              Szczegółowe informacje dotyczące
              przetwarzania danych oraz wykorzystywanych
              technologii znajdują się
              w Polityce prywatności.
            </li>
          </ol>
        </section>

        <section>
          <h2 className={style.SectionTitle}>
            §11. Reklamacje
          </h2>

          <ol>
            <li>
              Reklamacje dotyczące działania Serwisu
              oraz usług świadczonych przez CARTENA
              można przesyłać na adres
              kontakt@cartena.com.pl.
            </li>

            <li>
              Reklamacja powinna zawierać dane
              umożliwiające identyfikację zgłoszenia,
              opis problemu oraz adres e-mail
              do udzielenia odpowiedzi.
            </li>

            <li>
              Administrator udziela odpowiedzi
              na reklamację w terminie 14 dni
              od jej otrzymania, chyba że
              bezwzględnie obowiązujące przepisy
              przewidują inny termin lub skutki
              jego niedochowania.
            </li>

            <li>
              Odpowiedź na reklamację jest przekazywana
              na adres e-mail wskazany w zgłoszeniu.
            </li>

            <li>
              Jeżeli rozpatrzenie reklamacji wymaga
              dodatkowych informacji, Administrator
              może zwrócić się o ich uzupełnienie.
            </li>

            <li>
              Postanowienia niniejszego paragrafu
              nie ograniczają uprawnień użytkowników
              wynikających z obowiązujących
              przepisów prawa.
            </li>
          </ol>
        </section>

        <section>
          <h2 className={style.SectionTitle}>
            §12. Postanowienia końcowe
          </h2>

          <ol>
            <li>
              Regulamin jest dostępny nieodpłatnie
              w Serwisie, w sposób umożliwiający
              jego zapisanie i wydrukowanie.
            </li>

            <li>
              Administrator może aktualizować Regulamin,
              w szczególności w związku ze zmianą
              funkcjonalności Serwisu, sposobu
              świadczenia usług lub przepisów prawa.
            </li>

            <li>
              O zmianach Regulaminu mających wpływ
              na trwające umowy Administrator
              poinformuje użytkowników z odpowiednim
              wyprzedzeniem, wskazując zakres zmian,
              datę ich wejścia w życie oraz
              przysługujące użytkownikom uprawnienia.
            </li>

            <li>
              Zmiany Regulaminu nie naruszają
              praw nabytych ani uprawnień
              wynikających z obowiązujących
              przepisów prawa.
            </li>

            <li>
              W sprawach nieuregulowanych Regulaminem
              zastosowanie mają właściwe
              przepisy prawa polskiego.
            </li>

            <li>
              Regulamin obowiązuje od dnia
              jego opublikowania w Serwisie,
              z zastrzeżeniem zasad dotyczących
              wcześniej zawartych umów.
            </li>
          </ol>
        </section>
      </div>
    </PageLayout>
  );
};

export default Copyright;